import { render, staticRenderFns } from "./DormDetail.vue?vue&type=template&id=4bc3df9b&"
import script from "./DormDetail.vue?vue&type=script&lang=js&"
export * from "./DormDetail.vue?vue&type=script&lang=js&"
import style0 from "./DormDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports